export default __webpack_public_path__ + "9da361a4b35f6c5e34cf6119f3cfd0ca.png";